import React from 'react';
import { Col, Row } from 'components';
import { TaskComments } from 'feature/taskTabs/general/Comments';
import { SummaryDescription } from 'feature/taskTabs/general/SummaryDescription';
import styles from './styles.module.scss';
import { useGeneral } from './useGeneral';
import { TaskInfo } from './taskInfo';

interface ITaskGeneral {
  entity:
    | 'BRAND'
    | 'CLIENT'
    | 'ADMIN'
    | 'TASK'
    | 'SUPPLIER'
    | 'LEAD'
    | 'DEAL'
    | 'ITEM'
    | 'COUNTRY'
    | 'PURCHASE_REQUEST'
    | 'PURCHASE_ORDER';
  isFinalStatus?: boolean;
}

export const TaskGeneral = (props: ITaskGeneral) => {
  const { entity, isFinalStatus } = props;
  const { form, editMode, setEditMode, onUpdate, taskId } = useGeneral();
  return (
    <Row className={'gap-40'} wrap={false}>
      <Col className={styles.scroll_container} flex={'1'}>
        <Row>
          <Col span={24}>
            <SummaryDescription
              editMode={editMode}
              form={form}
              onUpdate={onUpdate}
              setEditMode={setEditMode}
              id={taskId}
              isFinalStatus={isFinalStatus}
            />
          </Col>
          <Col span={24}>
            <TaskComments hasAccessToWrite={true} id={taskId} isFinalStatus={isFinalStatus} />
          </Col>
        </Row>
      </Col>
      <Col flex={'300px'}>
        <TaskInfo id={taskId} entity={entity} isFinalStatus={isFinalStatus} />
      </Col>
    </Row>
  );
};
